import React from 'react';
import PropTypes from 'prop-types';

// 未收藏状态
const Collect = (props) => {
  const { type, iconClass, iconStyle, fill } = props;
  return (
    <React.Fragment>
      {type == 'product' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className={iconClass}
          style={iconStyle}>
          <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
              stroke={fill}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity={1}
              strokeWidth={1.125}
              d="m14.19 18.383-2.377 2.43-7.435-7.598c-.817-1.027-2.128-2.45-2.128-4.178 0-2.817 2.234-5.1 4.99-5.1 2.045 0 3.803 1.259 4.573 3.06.77-1.801 2.527-3.06 4.573-3.06 2.755 0 4.989 2.283 4.989 5.1"
            />
            <g
              stroke={fill}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity={1}
              strokeWidth={1.125}>
              <path d="M18.375 18.375v-7.876M14.25 14.25h7.875" />
            </g>
          </g>
        </svg>
      )}
      {type == 'tool' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          className={iconClass}
          style={iconStyle}>
          <g fill="none" fillRule="evenodd">
            <path d="M-2.5-3h20v20h-20z" />
            <path
              stroke={fill}
              strokeWidth={1.4}
              d="M10.586.7a3.675 3.675 0 0 1 3.685 3.675c0 2.965-3.524 6.322-5.52 8.05a46.31 46.31 0 0 1-1.12.925c-.877-.567-3.256-2.456-4.996-4.67C1.558 7.31.7 5.803.7 4.377A3.672 3.672 0 0 1 2.923 1a3.672 3.672 0 0 1 4.39 1.167c.154-.141.318-.278.493-.41C8.686 1.09 9.614.703 10.586.7Z"
            />
          </g>
        </svg>
      )}
    </React.Fragment>
  );
};

// 已收藏状态
const Collected = (props) => {
  const { type, iconClass, iconStyle, fill } = props;
  return (
    <React.Fragment>
      {type == 'product' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
          viewBox="0 0 64 64"
          className={iconClass}
          style={iconStyle}>
          <path
            d="M56.1 13.5c-4.9-4.6-12.6-4.6-17.4.2L32 20.4l-6.6-6.6-.2-.2C20.3 9 12.6 9 7.8 13.8c-4.9 4.9-4.9 12.8 0 17.7l24.3 24.3.1-.1.1.1 24.3-24.3.2-.2c4.6-4.9 4.6-12.6-.2-17.4l-.5-.4z"
            style={{
              fillOpacity: 1,
              fill
            }}
          />
        </svg>
      )}

      {type == 'tool' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          className={iconClass}
          style={iconStyle}>
          <g fill="none" fillRule="evenodd">
            <path d="M-2.5-3h20v20h-20z" />
            <path
              fill={fill}
              fillRule="nonzero"
              d="M10.585 0a4.375 4.375 0 0 0-2.998 1.2l-.102.098-.102-.098A4.375 4.375 0 0 0 0 4.375c0 4.376 7.062 9.586 7.361 9.805a.28.28 0 0 0 .343 0c.3-.223 7.267-5.47 7.267-9.805A4.375 4.375 0 0 0 10.585 0Z"
            />
          </g>
        </svg>
      )}
    </React.Fragment>
  );
};

// 收藏选择组件
const CollectionBtn = (props) => {
  return (
    <React.Fragment>
      {props.collect && <Collected {...props} />}
      {!props.collect && <Collect {...props} />}
    </React.Fragment>
  );
};

// 默认props
CollectionBtn.defaultProps = {
  // collect: false, // 收藏状态(必填)
  // fill: '#fff', // 填充颜色(必传)
  className: '', // 类名(可选)
  style: {}, // 样式(可选)
  iconClass: '', // 图标类名(可选)
  iconStyle: {
    width: 32,
    height: 32
  }, // 图标样式(可选)
  onClick: null, // 点击事件(可选)
  type: 'product' // 类型(可选) product: 商品, tool: 工具流  默认为商品
};

// 默认props类型检查
CollectionBtn.propTypes = {
  collect: PropTypes.bool.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  iconClass: PropTypes.string,
  iconStyle: PropTypes.object,
  onClick: PropTypes.func,
  type: PropTypes.any
};

export default CollectionBtn;



// WEBPACK FOOTER //
// ./src/pubBiz/CollectionBtn/index.js